import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { EmblaCarouselDirective } from 'embla-carousel-angular';
import AutoScroll from 'embla-carousel-auto-scroll';
import { FileUploadService } from '../../../core/file/file-upload.service';
import { FileService } from '@szebit-app/sdk/backend';
import { map, switchMap } from 'rxjs';
import { FileToUrlPipe } from '@pct-ng/feature-image-native';
import { isSuccessFileUploadResponse } from '@pct-ng/feature-file-upload-native';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AuditorDtoService } from '../../../dto/auditor/auditor-dto.service';
import { isNil } from '@pct-ts/typeguard';

type AuditorLogo = { alt: string | null; file?: File; url: string };

@Component({
  selector: 'app-auditors',
  templateUrl: './auditors.component.html',
  styleUrl: './auditors.component.scss',
  imports: [EmblaCarouselDirective, FileToUrlPipe, MatProgressSpinner],
  providers: [FileService, FileUploadService, AuditorDtoService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditorsComponent {
  readonly #fileUploadService = inject(FileUploadService);
  protected service = inject(AuditorDtoService);

  protected auditors: AuditorLogo[] | null = null;
  protected isLoading = signal(true);

  protected readonly plugins = [
    AutoScroll({
      playOnInit: true,
      stopOnMouseEnter: true,
      stopOnInteraction: false,
    }),
  ];

  constructor() {
    this.service
      .listAll()
      .pipe(
        switchMap(auditors => {
          const auditorsWithPhoto = auditors.filter(a => !isNil(a.photoId));
          return this.#fileUploadService
            .getByIds(auditorsWithPhoto.map(a => a.photoId!))
            .pipe(map(files => ({ auditors, files })));
        }),
      )
      .subscribe(({ auditors, files }) => {
        const fileMap = new Map(
          files.filter(f => isSuccessFileUploadResponse(f)).map(f => [f.id, f.file]),
        );
        this.auditors = auditors.map(auditor => ({
          alt: auditor.name,
          file: fileMap.get(auditor.photoId),
          url: `/auditors/${auditor.id}`,
        }));
        this.isLoading.set(false);
      });
  }
}
